import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    admins: [],
    selectedAdmin: null,
    loading: false,
    error: null,
    pagination: {
        page: 1,
        limit: 10,
        total: 0,
    },
};

const adminSlice = createSlice({
    name: 'admin',
    initialState,
    reducers: {
        setAdmins: (state, action) => {
            state.admins = action.payload;
        },
        setSelectedAdmin: (state, action) => {
            state.selectedAdmin = action.payload;
        },
        setPagination: (state, action) => {
            state.pagination = { ...state.pagination, ...action.payload };
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        addAdmin: (state, action) => {
            state.admins.unshift(action.payload);
        },
        updateAdmin: (state, action) => {
            const index = state.admins.findIndex((a) => a.id === action.payload.id);
            if (index !== -1) {
                state.admins[index] = action.payload;
            }
        },
        removeAdmin: (state, action) => {
            state.admins = state.admins.filter((a) => a.id !== action.payload);
        },
        clearError: (state) => {
            state.error = null;
        },
    },
});

export const {
    setAdmins,
    setSelectedAdmin,
    setPagination,
    setLoading,
    setError,
    addAdmin,
    updateAdmin,
    removeAdmin,
    clearError,
} = adminSlice.actions;

export default adminSlice.reducer;
